module.exports = __webpack_public_path__ + "img/topBc.7ed013f7.png";